// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { object } from 'prop-types'
import { DataItemWrapper } from './styles'

// This is the table cell or <td /> element

const DataItem = props => {
  const {
    columnData,
    rowData,
  } = props

  if (columnData.cell) {
    return (
      <columnData.cell
        columnData={columnData}
        rowData={rowData} />
    )
  }

  const label = rowData[columnData.field]

  const title = (
    columnData.hoverField
      ? rowData[columnData.hoverField]
      : label
  )

  return (
    <DataItemWrapper title={title}>
      {label}
    </DataItemWrapper>
  )
}

DataItem.propTypes = {
  columnData: object.isRequired,
  rowData: object.isRequired,
}

export default DataItem
